import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=6b828121&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=ts&"
export * from "./Form.vue?vue&type=script&lang=ts&"
import style0 from "./Form.vue?vue&type=style&index=0&id=6b828121&scoped=true&lang=css&"
import style1 from "./Form.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b828121",
  null
  
)

export default component.exports